export default {
  setDateSource(state, newDateSource) {
    state.dateSource = newDateSource;
  },
  setDateRange(state, newDateRange) {
    state.dateRange = newDateRange;
  },
  setWarehouseFilter(state, newWarehouseFilter) {
    state.warehouseFilter = newWarehouseFilter;
  },
  toggleLoadingTotalizers(state) {
    state.totalizers = state.totalizers.map(t => ({ ...t, loading: true }));
  },
  setTotalizerValues(state, newTotalizerValues) {
    state.totalizers = state.totalizers.map((t) => {
      const ref = newTotalizerValues.find(t2 => t2.field === t.field) || {};
      return ({ ...t, value: ref.value, loading: false });
    });
  },
  setLoadingBillingsTable(state, newLoadingBillingsTable) {
    state.loadingBillingsTable = newLoadingBillingsTable;
  },
  setBillingsByLogisticProvider(state, newBillingsByLogisticProvider) {
    state.billingsByLogisticProvider = newBillingsByLogisticProvider;
  },
  setLoadingBillingDetails(state, newLoadingBillingDetails) {
    state.loadingBillingDetails = newLoadingBillingDetails;
  },
  setLogisticProviderBillingDetails(state, newLogisticProviderBillingDetails) {
    state.logisticProviderBillingDetails = newLogisticProviderBillingDetails;
  },
  setLoadingBillingTemplates(state, newLoadingBillingTemplates) {
    state.loadingBillingTemplates = newLoadingBillingTemplates;
  },
  setSingleBillingTemplate(state, newSingleBillingTemplate) {
    state.singleBillingTemplate = newSingleBillingTemplate;
  },
  setClientBillingTemplates(state, newClientBillingTemplates) {
    state.clientBillingTemplates = newClientBillingTemplates;
  },
  setLoadingBillingFiles(state, newLoadingBillingFiles) {
    state.loadingBillingFiles = newLoadingBillingFiles;
  },
  setBillingUploadFiles(state, newBillingUploadFiles) {
    state.billingUploadFiles = newBillingUploadFiles;
  },
  setBillingExtractionFiles(state, newBillingExtractionFiles) {
    state.billingExtractionFiles = newBillingExtractionFiles;
  },
  setSavingBillingUpload(state, { saving, error }) {
    state.savingBillingUpload = saving;
    state.savingBillingUploadError = error;
  },
  setLoadingExtractDetail(state, newLoadingExtractDetail) {
    state.loadingExtractDetail = newLoadingExtractDetail;
  },
  setLoadingBillingTemplatePreview(state, newLoadingBillingTemplatePreview) {
    state.loadingBillingTemplatePreview = newLoadingBillingTemplatePreview;
  },
  setSavingBillingTemplate(state, { saving, error }) {
    state.savingBillingTemplate = saving;
    state.savingBillingTemplateError = error;
    if (!saving) {
      state.previewMap = {};
    }
  },
  setPreviewMap(state, newPreviewMap) {
    state.previewMap = newPreviewMap;
  },
};




// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/billing/store/mutations.js